/**
 * 日文
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "中国語",
			langimg: "../assets/zg.png"
		},
		{
			type: "English",
			name: "英語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "中国語繁体字",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "日本語",
			langimg: "../assets/zg.png"
		},

		{
			type: "Vietnamese",
			name: "ベトナム語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "マレー語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: "インド語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "タイ語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "ロシア語",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "インドネシア語",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "Japanese",
		langimg: "../assets/zg.png"
	},

	tabbar: { //底部
		index: "トップページ",
		activity: "アクティブ",
		to_promote: "広める",
		help: "ヘルプ",
		my: "私の"
	},
	// 提示
	prompt: {
		verification: "認証コードエラー",
		account: "アカウント8-20桁の純数字またはアルファベット",
		password: "パスワードが6桁以上の数字+アルファベットまたは文字の組み合わせ",
		two: "2回のパスワードが一致しません",
		yizhi: 'パスワードとアカウントは同じではありません',
		successful: "登録成功",
		loginsuccessful: "ログイン成功",
		null: "アカウントのパスワードを空にすることはできません",
		Binding: "バインド成功",
		buzhengque: 'アドレスフォーマットが正しくありません',
		address: "住所を記入してください",
		Please_choose: "まず1つを選択して発注金額を入力してください",
		Bet_type: "まず注釈のタイプを選択してください",
		success: "コメント成功",
		complete_password: "完全なパスワードを入力してください",
		copy_success: "クリップボードにコピー",
		copy_fail: "コピー失敗",
		Set_success: "設定成功",
		Set_password: "6桁のパスワードを設定してください。「アルファベット、適合、スペース」は含まれません。",
		update_success: "修正に成功しました",
		input_number: "数量を入力してください",
		addressvalue: "財布の住所を選択してください"
	},
	head: { //头部
		luckyhash: "ハッシュ・ノート",
		address: "財布アドレスのバインド",
		history: "賭けの歴史",
		help: "ヘルプ",
		lotteryRecord: "授賞記録.",
		notice: "公告リスト",
		question: "よくある質問",
		performance: "奨励する",
		add_address: "ウォレットの追加",
		asset: "資産パスワード",
		balance: "残高詳細",
		exchangeRecord: "両替",
		forrecord: "両替記録",
		language: "言語設定",
		update_assets_password: "資産パスワードの変更",
		update_login_password: "ログインパスワードの変更",

		myteam: "私のチーム",
		recharge: "残高チャージ",
		setting: "設定",
		transactiondetails: "賭け記録",
		transfer: "コミッション移転",
		user: "パーソナルセンター",
		userInfo: "個人情報",
		withdrawal: "現金を引き出す",
		commission: "コミッション引出",
		withdrawalRecord: "現金引き出し記録",
		top_up: "チャージレコード"
	},
	withdrawalRecord: {
		Select_month: "月を選択",
		afterPrice: "残高",

	},
	withdrawal: {
		withdrawalrecord: "現金引き出し記録",
		commission: "現金化可能な資産",
		number: "移動する数量",
		withdrawal_number: "金引き出し数量",
		money_address: "財布の住所",
		addressvalue: "入金財布の住所を選択してください",
		poundage: "手数料",
		immediately: "即座に現金を引き出す.",
		Warm_prompt: "ご注意:正しい財布の住所を記入してください。そうしないと、お金を引き出すことができません。お金を引き出す財布の住所は記入すると修正できません。修正が必要な場合は、カスタマーサービスに連絡してください。",
		input_password: '資産のパスワードを入力してください',
		betting: "に賭ける",

	},
	userInfo: {
		Head_portrait: "プロフィール",
		account: "アカウント",
		Choose_picture: "アイコンの選択",
		cancel: "キャンセル",
		determine: "を選択します。"
	},
	user: {
		wallet_account: "財布口座",
		balance: "残高詳細",
		top_up: "チャージ",
		withdrawal: "現金を引き出す",
		my_wallet: "私の財布",
		add_wallet: "ウォレットの追加",
		look: "レコードの表示",
		look_all: "詳細を表示",
		Pack_up: "ひきあげる",
		For_record: "両替記録",
		bettingRecord: "取引明細",
		reward: "奨励金を広める.",
		goCustomerLink: "サービス",
		Commission_account: "コミッション口座",
		transfer: "てんい",
		number: "賭けデータ",
		transactiondetails: "詳細の表示",
		day: "きょう賭けをする",
		day_winning: "きょう当選する",
		my_team: "私のチーム",
		about_we: "私たちについて",
		center: "カスタマーセンター",
		setting: "設定",
		delete: '削除',
		isDelete: "財布の削除を確認"
	},
	transfer: {
		money: "コミッション残高",
		account_balance: "口座残高",
		number: "移動する数量",
		select: "選択してください",
		Immediately_transfer: "そくじてんい",
		password: "資産のパスワードを入力してください",
		betting: "に賭ける",

	},
	transactiondetails: {
		type: "を選択します。",
		input_type: "タイプを選択してください",
		date: "日付",
		select_date: "日付を選択してください",
		select: "検索",
		bettingmoney: "賭け金",
		winning_amount: "当せん金",
		time: "時間",
		not: "データなし",
		noopen: 'まだオープンしていません',
		B1: 'ラッキーハッシュ-ラッキーサイズ',
		B2: 'ラッキーハッシュ-ラッキーグループ',
		B3: 'ラッキーハッシュ-ラッキードラゴントラ',
		B4: 'ラッキーハッシュ-ラッキー荘閑',
		B5: 'ラッキーハッシュ-ラッキーナンバー',
		A1: 'エンターテインメント-ラッキーレーシングカー',
		A2: 'エンターテインメント-ラッキーボート',
		A3: 'エンターテインメント-ラッキー競馬',
		A4: 'エンターテインメント-ラッキーサイズ',
		A5: 'エンターテインメント-ラッキーグループ',
		A6: 'エンターテインメント-ラッキードラゴントラ',
		A7: 'エンターテインメント-ラッキー荘閑',
		A8: 'エンターテインメント-ラッキーナンバー',
		options: [{
			value: "ラッキーハッシュ-両面",
			label: "B1",
		},
		{
			value: "ラッキーハッシュ-コンビネーション",
			label: "B2",
		},
		{
			value: "ラッキーハッシュ-龍虎合",
			label: "B3",
		},
		{
			value: "ラッキーハッシュ-百家楽",
			label: "B4",
		},
		{
			value: "ラッキーハッシュ-独胆",
			label: "B5",
		},
		],
	},
	setting: {
		updatepwd: "ログインパスワードの変更",
		assets_pwd: "資産パスワード",
		not: "設定されていません",
		yes: "設定済み",
		language: "言語設定",
		exit: "終了",

	},
	recharge: {
		recharge_code: "チャージレコード",
		Chain_type: "チェーンタイプ",
		address: "チャージアドレス",
		copy_address: "アドレスのコピー",
		remind: "アクションアラート",
		content: "コンテンツコンテンツコンテンツコンテンツコンテンツコンテンツコンテンツ",
		copy_success: 'コピー成功'
	},
	myteam: {
		select: "検索",
		time: "日付",
		money: "当日コミッション",
		people: "直属人数",
		team: "チーム",
		zsxx: "UIDを入力して直属プレイヤー情報を表示してください",
		jryj: '今日の結果',
		jrsy: '今日の収益',
		ljsy: '累積収入',
		friendsCategoryList: ['一流の友達', '二次友人', 'サードレベルの友達', '4年生の友達', '5レベルの友達'],
	},
	login: {
		order_password: "古いパスワード",
		input_ordpwd: "古いパスワードを入力してください",
		new_pwd: "新しいパスワード",
		number: "6～16ビットの大文字と小文字+数字を設定してください",
		six_pwd: "6桁の数字のパスワードを入力してください",
		confirmPassword: "パスワードの確認",
		confirm: "確認",
	},
	forrecord: {
		spending: "両替支出",
	},
	exchangeRecord: {
		exchangeRecord: "両替",
		record: "きろく",
		For_spending: "両替支出",
		money: "両替金額",
		exchange_number: "換算数量",
		number: "数量",
		market_price: "相場",
		Miners_fee: "鉱夫費",
		input_money: "両替金額を入力してください",
		Get_the_amount: "取得金額",
		Can_be: "取得可能金額",
		address: "財布の住所",
		Immediatelychange: "即時換算",
		Warm_prompt: "お知らせ",
		details: "詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細詳細"
	},
	balance: {
		balance_of: "残高",
		data: "日付",
		dataPickerRange: "選択してください",
		select: "検索",
		to: 'to'
	},
	asset: {
		password: "6桁のパスワードを設定してください。「アルファベット、適合、スペース」は含まれません。",
		confirm: "確認",
	},
	add_address: {
		money_address: "ウォレットアドレスを入力してください（TRC 20）",
		save: "保存＃ホゾン＃"
	},
	spread: {
		cumulative: "累計招待",
		people: "人",
		make: "もうかる",
		Continue_to: "引き続き努力して大賞に衝撃を与えます",
		url: "リンクの共有",
		Friends_registered: "友達登録",
		money: "財布のリンク",
		Friends_deal: "友達取引",
		copy_url: "リンク招待のコピー",
		my_group: "私のチーム",
		look: "実績詳細の表示",
		directCount: "直属人数",
		group: "チーム数",
		Commission_withdrawal: "コミッション引出",
		historyAward: "履歴受領コミッション",
		yesterdayAward: "昨日コミッション",
		currentAward: "現在のコミッション",
		todayAward: "今日の実績",
		my_invite: "私の招待コード",
		copy_invite: "招待コードのコピー",
		top_title: "私の上司",
		update: "親をバインドしても変更できません",
		nikname: "バインドする親ニックネームを入力してください",
		binding: "バインディング",
		Commission_ratio: "コミッションの割合",
		level: "レベル",
		ratio: "リベート割合",
		Directly_under: "直属部下",
		first: "第",
		levelone: "レベル",

	},
	performance: {
		datatime: "日付",
		pick: "選択してください",
		select: "検索",
		total: "本日の総業績",
		performance: "業績明細",
		directCount: "直属プレイヤー数",
		todayTotalPerformByDirect: "今日の直属プレイヤーの業績",
		other: "その他プレイヤー数",
		todayTotalPerformByOther: "その他のプレイヤーの実績",
		Commission_withdrawal: "コミッション引出",
		historyAward: "履歴受領コミッション",
		yesterdayAward: "昨日コミッション",
		currentAward: "現在のコミッション",
		todayAward: "今日の実績",
		Commission_ratio: "コミッションの割合",
		level: "レベル",
		ratio: "リベート割合",
		Directly_under: "直属の部下",
		first: "第",
		levelone: "レベル",
	},
	lotteryRecord: { //开奖记录
		block: "ブロック",
		highly: "ブロック高さ",
		results_of: "結果",

	},
	help: {
		DAPP: "DAPPゲームステップ",
		a: "DAPPのゲームアドレスをコピーしてUSDT-TRC 20の振り替えを行います",
		b: "ウォレットブロックチェーンブラウザ(TRXネットワーク)で当サイトを開くと、DAPPをすぐに賭け、コピーする必要はありません。",
		Focus_on: "常にホームページを更新し、最新の取引先を取得することに注目してください。",
		login: "登録波場公式サイト検索ブロックハッシュ値",
		hash: "波場公式サイトでブロックハッシュ値を検索できます",
		you: "波場公式サイトにて",
		login_website: "波場公式サイトへの登録",
		query: "ブロックハッシュ値を問い合わせる",
		look: "クリックしてチュートリアルを表示",
		congratulations: "おめでとうございます",
		winning: "当選した場合、システムは1分以内に返金されます",
		address: "当選した場合、システムは1分以内にあなたの振り替え住所に戻ります。",
		number: "デジタルコイン取引所でUSDTとTRXを購入",
		skip: "財布にUSDTとTRXがある場合は、この手順をスキップします。",
		Digital_currency: "デジタルコイン取引所でUSDTとTRXを購入し、USDTとTRXを[中心財布]に転送します。以下の中心財布サイトに登録されている財布を使用できます。",
		platform: "プラットフォーム",
		url: "Webサイト",
		tutorial: "チュートリアル",
		vpn: "友情のヒント：Telegramを開けないならば、神VPNを使うことができます",
		vpnurl: "神灯VPNのウェブサイト",
		whirlwind: "サイクロンアクセルのウェブサイト",
		can_login: "ログイン可能",
		why: "なぜxxxxを選んだのか",
		most_fair: "最も公平である",
		play: "人を蹴らず、糸を落とさず、何の干渉も受けない。",
		Publicly_available: "ブロックハッシュ値はランダムに生成され、結果は統一され、変更できず、公開的に調べることができる。",
		security: "最も安全",
		no_money: "運営資金を見れば、返金するお金がない心配はありません。",
		Cannot: "すべての人の振り替え記録が見え、虚偽の宣伝はできない。",
		Visi_convenient: "最も便利",
		Without_registration: "登録不要、プリチャージ不要、引き出し申請不要",
		questions: "よくある質問",
		one: "ブロックハッシュ値とは",
		dna: "ブロックハッシュ値は、データのDNAであり、各ブロックハッシュ値は一意でランダムであり、解読不可能である。",
		lookintroduce: "百度の百科事典のハッシュ値の紹介をクリックします。",
		what: "ブロックチェーンって何",
		Block_chain: "ブロックチェーンは本質的に、データまたは情報に格納された共有データベースです。偽造不可、全過程に痕跡を残す、遡及可能、公開透明、集団メンテナンスなどの特徴がある。",
		wallet: "財布を中心に?財布を中心化しますか?なぜ中心化財布は振り替えを調べることができないのですか?",
		example: "例えば、自分の財布の住所はAで、住所Eに10 USDTを転送しますが、取引ハッシュ値で検索すると、サービス業者のランダムな帳簿住所B(またはCまたはDなど)とEの振り替えしか検索できません。同じ理屈でEもこの10個のUSDTがあなたが転送したかどうか分からない。Eは帳簿アドレスBが彼に10個のUSDTに転送したのを見るしかないからだ。これは、中心化された財布が靴の上で実際の振り替え情報を調べることができない理由です。",
		why_winning: "なぜ私は連続的に当選したり、当選しなかったりしますか",
		First: "まず何度も当選しないのは小確率イベントです",
		small: "しょうかくりつイベントていぎ",
		second: "次に、当選と不当選はランダムなイベントであり、ランダムなイベントの発生頻度は安定した値になります。非反復の場合、物事が現れる確率は一人一人にとって等しく、この場合、一人一人が公平である。同時にランダムイベントは大数の法則(試験が変わらない条件の下で、何度も試験を繰り返し、ランダムイベントの周波数はその確率の大数の法則の定義に近似する)に従い、振り替えの頻度が絶えず増加する場合、当選と不当選の確率は1つの安定値になる。だから、振り替えを続けてください。振り替えの頻度が増えるにつれて、当選の総確率が高くなります。",
		whydelay: "なぜ入金が遅れるのか",
		Click_to_view: "クリックしてブロックチェーンの速度を表示します。",
		six: "なぜ通貨を転送するときに鍵があるのか、それではUSDTのタイプオプションがありますか?どちらを選べばいいですか?",
		global: " 世界には多くの有名な公鎖がある。",
		click_look: "クリックして全世界の知格の公の鎖の紹介を見ます",
		how: "コインを振り替えるときに住所を振り替えたり、コインのタイプを間違えたりしたらどうしますか?まだ帰れますか?",
		For_instance: " 例えば、私たちに送金するときはUSD下TRC 20型を選ぶべきですが、他のタイプのUSD下OMNIやUSDERC 20を選ぶと、コインを失うことになります。このような状況は戻ってきません。",
		How_to_force: "コインを間違えたらどうする?",
		Other_problems: "その他の質問",
		callwe: "何かご質問がございましたらご連絡ください",
		immediately: "即時賭け",
		company: "会社情報",
		link: "友情リンク",
		register: "デジタルコインを登録して財布を中心化します",
		Already_have: "すでに財布を持っている場合は、この手順をスキップします。",
		download: "デジタルコインをダウンロードして登録して財布を中心化します",
		com_title: "デジタルコイン財布関連サイトのチュートリアルは以下の通りです。"
	},
	register: { //登录注册
		login_tips: "ログインパスワードを再設定してください",
		address: "財布の住所を入力してください",
		confirm: "パスワードの確認",
		confirmupdate: "修正の確認",
		toRegister: "登録に行く",
		agreement: "ログイン同意",
		user: "ユーザプロトコル",
		policy: "プライバシーポリシー",
		welcome: "ようこそいらっしゃいました",
		login: "アカウントにログイン",
		forget: "パスワードを忘れる",
		nowLogin: "ログイン",
		nologin: "ログインを保留中",
		new: "新しいアカウントを作成",
		login: "ログインアカウントとして",
		account: "アカウント8-20桁の純数字またはアルファベット",
		password: "パスワードが6桁以上の数字+アルファベットまたは文字の組み合わせ",
		confirm_password: "パスワードの確認",
		inviteCode: "招待コードを入力してください(選択)",
		verificationCode: "認証コードを入力してください",
		toRegister: "登録",
		noaccount: "アカウントがありません",
		toLogin: "ログイン"
	},
	address: {
		warmprompt: "ご注意:正しい財布の住所を記入してください。そうしないと、お金を引き出すことができません。お金を引き出す財布の住所は記入すると修正できません。修正が必要な場合は、カスタマーサービスに連絡してください。",
		tips: "少なくとも1つの財布の住所を縛って、パスワードを忘れた時に取り戻すことができません",
		TRC20: "入力ミスを避けるため、コピーしてここに長く押して貼り付けてください（TRC 20）",
		toBind: "今すぐバインド",
		noBind: "バインドを保留",
	},
	luckyhash: { //幸运哈希
		walletName: '財布のリンク',
		exchange: "両替",
		reward: "奨励する",
		Customerservice: "サービス",
		instructions: "説明",
		luckyhash: "ラッキーハッシュ",
		entertainment: "エンターテインメント",
		Doublesided: "ラッキーサイズ",
		odds: "賠償率",
		immediately: "即時賭け",
		combination: "幸運の組み合わせ",
		LongHuge: "ラッキードラゴンタイガー",
		baccarat: "幸運荘閑",
		gallbladder: "ラッキーナンバー",
		Hashracingcar: "ラッキーレーシングカー",
		Hashspeedboat: "ラッキーヨット",
		Hashracing: "ラッキー競馬",
		bothsides: "ラッキーナンバー",
		problem: "よくある質問",
		all: "詳細を表示",
		friend: "パートナー"
	},
	history: {
		block: "ブロック",
		type: "を選択します。",
		big: "大きい",
		highly: "ブロック高さ",
		results_of: "結果"
	},
	entertainment: {
		lastBlock: "前期ブロック",
		resultValue: "表彰の結果.",
		currentblock: "現在のブロック",
		nextBlock: "今回のボーナスブロック",
		toLotteryRecord: "授賞記録.",
		block: "ブロック",
		money1: "金額",
		type: "を選択します。",
		all: "詳細を表示",
		both_sides: "両面",
		big: "大きい",
		small: "小さい",
		single: "シングル",
		double: "ダブル",
		champion: "チャンピオン人",
		yajun: '準優勝',
		he: 'と',
		champion_one_size: "チャンピオンコード",
		crown: "冠亜和",
		andbig: "和大",
		andsmall: "と小さい",
		andsingle: "和単",
		anddouble: "和双",
		championtwo: "チャンピオンの両面",
		combination: "コンポジット",
		forlarge: "大単",
		smallsingle: "小単",
		large_double: "ダブル",
		small_double: "ダブル",
		Long_Huge: "竜虎合",
		dragon: "ドラゴン",
		tiger: "虎",
		us: "合",
		baccarat: "百家楽",
		zhuang: "庄",
		idle: "暇",
		gallbladder: "独胆",
		Atotalof: "共に",
		note: "注",
		Check_the_details: "詳細の表示",
		money: "財布残高",
		pause: "マシンセレクト",
		reset: "リセット",
		inputmoney: "金額を入力してください",
		submit: "送信",
		password: "取引パスワードを入力してください",
		betting: "に賭ける",
		determine: "を選択します。",
	},
	announcement: {
		title: '最新のお知らせ',
		close: '閉鎖',
	},
	details: {
		block: "ブロック",
		money: "金額",
		type: "を選択します。",
		resultValue: "表彰の結果.",
		all: "詳細を表示",
		address: "ベットアドレス",
		toLotteryRecord: "授賞記録.",
		money: "財布を賭ける",
		copy: "賭け先のコピー",
		ts: "取引所の住所は使用しないでください。そうしないと、返金は受けられません。",
		USDT: "波場USDT/TRX(Trc 20)に振り替えてください",
		Betting_amount: "賭け金",
		inputmoney: "賭け金額を入力してください",
		confirm: "確認",
		cancel: "キャンセル",
	},
	data: {
		noData: 'データが一時的にありません',
		deleteSuc: '削除成功',
		iscon: 'ベットを確認しますか？',
		fenpan: '封盤中、期間中は下注不可',
		erweima: '2次元コードの保存'
	},
	phone: {
		title: '携帯番号をバインドする',
		phone: '携帯番号',
		input: 'バインドされた携帯番号を入力してください',
		code: '認証コード',
		inputcode: "認証コードを入力してください",
		getCode: '認証コードの取得',
		details: 'まず市外局番、携帯番号を記入してください',
		success: '認証コード送信成功',
		bsuccess: 'バインド成功',
		jiaoyi: 'まず取引パスワードを設定してください',
		caozuo: "操作が成功しました",
		touxiang: "アイコンを選択してください",
		buzu: '残高不足',
		tuiguan: '普及センター',
		qubie: 'クリックしてブロックチェーンウォレットの違いを表示します',
		yhm: 'ユーザー名を入力してください',
		mm: 'パスワードを入力してください',
		xqgg: 'まず遊びに行きます。',
		llwm: 'お問い合わせ',
		lj: 'まず財布を接続してください',
		dk: 'ウォレットアプリで開けてください',
		qd: 'ご参加をお待ちしております',
		yjmx: 'コミッション明細'
	},
	vip: {
		jl: "奨励",
		xrjl: '新人奨励',
		ckgz: 'ルールの表示',
		zcsj: '登録送り金',
		qbsj: '携帯電話と財布の住所をバインドする',
		dlq: '受け取り待ち',
		qwc: '完了します',
		ylq: '受領済',
		tgrw: '任務を広める',
		rwjl: '任務奨励',
		yq: 'に勧める',
		ghy: '良質の親友',
		lqcg: '受け取り成功',
		bz: "チャージ通貨を入力してください",
		je: 'チャージ金額を入力してください',
		xyb: '次へ',
		czpz: 'チャージ証明書をアップロードしてください',
		zzhx: '振替ハッシュを入力してください',
		ljtj: '今すぐ送信'

	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/Japanese.js